import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VerticalSpace, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
import { Avatar, Box, Button, Paper, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { fetchUserProfile } from "../../services/api/UserService";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/slices";
import { useParams } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"; // 🌟 Import error icon
import { selectUser } from "../../store/slices/user-slice";
var ProfilePage = function () {
    var _a;
    var username = useParams().username;
    var _b = useState(null), profileData = _b[0], setProfileData = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1]; // 🌟 New state for error message
    var dispatch = useDispatch();
    var userMetadata = useSelector(selectUser.userMetaData);
    var avatarContent = useMemo(function () {
        var _a, _b;
        if (!profileData)
            return "";
        // Prioritize name initial, then email initial, then fall back to username initial
        return profileData.profile.fullName
            ? profileData.profile.fullName[0]
            : ((_a = profileData.profile.email) === null || _a === void 0 ? void 0 : _a[0]) ||
                ((_b = profileData.profile.username) === null || _b === void 0 ? void 0 : _b[0]) ||
                "";
    }, [profileData]);
    var loadProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, err_1, errorMessage;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!username)
                        return [2 /*return*/];
                    dispatch(setLoading(true));
                    setError(null); // Clear any previous errors
                    setProfileData(null); // Clear previous data
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchUserProfile(username)];
                case 2:
                    data = _c.sent();
                    if (data.statusCode === 200) {
                        setProfileData(data.result);
                    }
                    else {
                        throw new Error();
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _c.sent();
                    console.error("Failed to load user profile:", err_1);
                    errorMessage = ((_b = (_a = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
                        "User not found or connection failed.";
                    setError(errorMessage);
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setLoading(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadProfile();
    }, [username]); // 🌟 Added 'username' dependency to refetch when route changes
    // --- CONDITIONAL RENDERING ---
    if (error) {
        // 🌟 RENDER ERROR STATE
        return (_jsx(WrapperContainer, { "$margin": "4rem 0 0 0", children: _jsxs(Paper, { elevation: 3, sx: {
                    p: 4,
                    textAlign: "center",
                    maxWidth: 500,
                    mx: "auto",
                    mt: 8,
                    border: "2px solid",
                    borderColor: "error.main",
                    borderRadius: "12px",
                }, children: [_jsx(ErrorOutlineIcon, { sx: { fontSize: 60, color: "error.main", mb: 2 } }), _jsx(Typography, { variant: "h5", color: "error", gutterBottom: true, children: "Profile Not Found" }), _jsxs(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: ["The user could not be found.", _jsx("br", {}), "Details: *", error, "*"] }), _jsx(Button, { variant: "contained", onClick: function () { return window.history.back(); }, children: "Go Back" })] }) }));
    }
    // 🌟 RENDER SUCCESS STATE
    if (!profileData)
        return null;
    return (_jsx(WrapperContainer, { "$margin": "4rem 0 0 0", children: _jsxs(Paper, { elevation: 3, sx: { p: 4, maxWidth: 600, mx: "auto", borderRadius: "12px" }, children: [_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", mb: 3, children: [_jsx(Avatar, { src: (profileData === null || profileData === void 0 ? void 0 : profileData.profile.profilePhotoUrl) || undefined, sx: { width: 80, height: 80, mb: 2, bgcolor: "secondary.main" }, children: avatarContent }), _jsx(Typography, { variant: "h4", gutterBottom: true, children: (profileData === null || profileData === void 0 ? void 0 : profileData.profile.fullName) || "Guest User" }), _jsxs(Typography, { variant: "body2", color: "primary.main", sx: { fontWeight: "bold" }, children: ["@", profileData === null || profileData === void 0 ? void 0 : profileData.profile.username] }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mt: 1 }, children: profileData === null || profileData === void 0 ? void 0 : profileData.profile.email })] }), _jsx(VerticalSpace, {}), _jsxs(Box, { sx: {
                        display: "flex",
                        justifyContent: "space-around",
                        textAlign: "center",
                    }, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: "h5", color: "primary", children: (_a = profileData === null || profileData === void 0 ? void 0 : profileData.totalTrips) !== null && _a !== void 0 ? _a : 0 }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: "Trips Created" })] }), _jsxs(Box, { children: [_jsx(Typography, { variant: "h5", color: "primary", children: (profileData === null || profileData === void 0 ? void 0 : profileData.memberSince) || "-" }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: "Member Since" })] })] }), _jsx(VerticalSpace, {}), profileData.profile.username === (userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.profile.username) && (_jsx(Box, { display: "flex", justifyContent: "center", children: _jsx(Button, { variant: "contained", color: "error", children: "Log Out" }) }))] }) }));
};
export default ProfilePage;
